/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationAssetControllerSuggestMappingsRequest
 */
export interface OrganizationAssetControllerSuggestMappingsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationAssetControllerSuggestMappingsRequest
     */
    headers: Array<string>;
    /**
     * Bypass the cache and generate fresh AI suggestions
     * @type {boolean}
     * @memberof OrganizationAssetControllerSuggestMappingsRequest
     */
    forceRefresh?: boolean;
}

/**
 * Check if a given object implements the OrganizationAssetControllerSuggestMappingsRequest interface.
 */
export function instanceOfOrganizationAssetControllerSuggestMappingsRequest(value: object): value is OrganizationAssetControllerSuggestMappingsRequest {
    if (!('headers' in value) || value['headers'] === undefined) return false;
    return true;
}

export function OrganizationAssetControllerSuggestMappingsRequestFromJSON(json: any): OrganizationAssetControllerSuggestMappingsRequest {
    return OrganizationAssetControllerSuggestMappingsRequestFromJSONTyped(json, false);
}

export function OrganizationAssetControllerSuggestMappingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAssetControllerSuggestMappingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'headers': json['headers'],
        'forceRefresh': json['forceRefresh'] == null ? undefined : json['forceRefresh'],
    };
}

export function OrganizationAssetControllerSuggestMappingsRequestToJSON(json: any): OrganizationAssetControllerSuggestMappingsRequest {
    return OrganizationAssetControllerSuggestMappingsRequestToJSONTyped(json, false);
}

export function OrganizationAssetControllerSuggestMappingsRequestToJSONTyped(value?: OrganizationAssetControllerSuggestMappingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headers': value['headers'],
        'forceRefresh': value['forceRefresh'],
    };
}

